import CONSTANTS from '../constants'
import { postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'


export const promocodePost = (creds) => (dispatch) => {
    let payload = {...creds, 'device_type': 'web'}
    dispatch(addEventLog(payload, CONSTANTS.PROMOCODE_REQUEST))
    dispatch({ type: CONSTANTS.PROMOCODE_REQUEST })
    return postRequest(APICONFIG.getFaclityUrl, payload).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.PROMOCODE_SUCCESS))
        dispatch({ type: CONSTANTS.PROMOCODE_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.PROMOCODE_FAILURE))
        dispatch({ type: CONSTANTS.PROMOCODE_FAILURE })
        return err
    })
}

export const applyPromoOnTicket = (ticket) => (dispatch) => {
    let payload = {...ticket, 'device_type': 'web'}
    dispatch(addEventLog(payload, CONSTANTS.PROMOCODE_TICKET_REQUEST))
    dispatch({ type: CONSTANTS.PROMOCODE_TICKET_REQUEST })
    return postRequest(APICONFIG.applyPromoCode, payload).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.PROMOCODE_TICKET_SUCCESS))
        dispatch({ type: CONSTANTS.PROMOCODE_TICKET_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.PROMOCODE_TICKET_FAILURE))
        dispatch({ type: CONSTANTS.PROMOCODE_TICKET_FAILURE })
        return err
    })
}